<template>
    <div
        v-if="errorMessage"
        class="flex items-center gap-2 text-[12.5px] rounded-2.5 px-3 py-2.5
               animate-[msgIn_0.18s_ease]
               text-red-800 dark:text-red-720
               bg-red-100 dark:bg-red/10
               border border-red/20 dark:border-red-720/25"
    >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="16" r="0.5" fill="currentColor" stroke="currentColor" stroke-width="1.5"/>
        </svg>

        {{ errorMessage }}
    </div>
</template>

<script setup>
defineProps({
    errorMessage: {
        type: String,
        default: '',
    },
})
</script>
